import React, { useState } from 'react';
import '../assets/css/Gallery.css';

import img1 from '../assets/Gallery/eve.JPG';
import img2 from '../assets/Gallery/eve1.JPG';
import img3 from '../assets/Gallery/eve2.JPG';
import img4 from '../assets/Gallery/eve3.JPG';
import img5 from '../assets/Gallery/eve4.JPG';
import img6 from '../assets/Gallery/eve5.JPG';
import img7 from '../assets/Gallery/eve6.JPG';
import img8 from '../assets/Gallery/eve7.JPG';

const galleryData = [
  { id: 1, src: img1, title: 'Workshop: Real Estate Basics' },
  { id: 2, src: img2, title: 'Seminar: Channel Partner Training' },
  { id: 3, src: img3, title: 'Seminar: Channel Partner Training' },
  { id: 4, src: img4, title: 'Seminar: Channel Partner Training' },
  { id: 5, src: img5, title: 'Seminar: Channel Partner Training' },
  { id: 6, src: img6, title: 'Seminar: Channel Partner Training' },
  { id: 7, src: img7, title: 'Seminar: Channel Partner Training' },
  { id: 8, src: img8, title: 'Seminar: Channel Partner Training' },
];

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openModal = (index) => setSelectedIndex(index);
  const closeModal = () => setSelectedIndex(null);

  const prevImg = () => {
    setSelectedIndex((prev) => (prev === 0 ? galleryData.length - 1 : prev - 1));
  };

  const nextImg = () => {
    setSelectedIndex((prev) => (prev === galleryData.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      {/* Hero Section */}
      <div className="gallery-hero-banner">
        <div className="overlay">
          <h1 className="hero-title">Gallery</h1>
          <p className="hero-subtitle">Gurukul Moments Captured in Time</p>
        </div>
      </div>

      <section className="gallery-section">
        <div className="gallery-grid">
          {galleryData.map((item, index) => (
            <div key={item.id} className="gallery-item" onClick={() => openModal(index)}>
              <img src={item.src} alt={item.title} />
              <div className="gallery-title-overlay">{item.title}</div>
            </div>
          ))}
        </div>

        {selectedIndex !== null && (
          <div className="gallery-modal" onClick={closeModal}>
            <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
              <img src={galleryData[selectedIndex].src} alt={galleryData[selectedIndex].title} />
              <p className="modal-title">{galleryData[selectedIndex].title}</p>

              {/* Slider controls */}
              <span className="modal-prev" onClick={prevImg}>&#10094;</span>
              <span className="modal-next" onClick={nextImg}>&#10095;</span>

              <span className="modal-close" onClick={closeModal}>&times;</span>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Gallery;
